import { render, staticRenderFns } from "./mwe-popbox.vue?vue&type=template&id=17620884&comments=true&"
import script from "./mwe-popbox.vue?vue&type=script&lang=js&"
export * from "./mwe-popbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports